import { UserPermission } from "../../models/UserPermission";

export const PERMISSIONS: UserPermission[] = (() => {
  // Group definitions to organize permissions
  const groups = [
    'Child Master',
    'Counselling',
    'Dashboard',
    'Depository',
    'Donation Reports',
    'Education',
    'Education Reports',
    'Inventory',
    'Masters',
    'Operations Dept',
    'Ops Reports',
    'Reminders',
    'Transport',
    'Donor Management',
    'Tasks'
  ] as const;

  // Base permission template
  const createPermission = (
    functionName: string,
    group: string
  ): UserPermission => ({
    functionName,
    group,
    add: false,
    all: false,
    archive: false,
    edit: false,
    excel: false,
    showMenu: false,
    view: false
  });

  // Clean and deduplicate permissions
  const rawPermissions = [
   // Child Master
    createPermission('Child Admission', 'Child Master'),
    createPermission('Child List', 'Child Master'),
    createPermission('Child Prescreening', 'Child Master'),
    createPermission('Child Highlights', 'Child Master'),
    createPermission('Case Study', 'Child Master'),
    createPermission('Child Call And Follow-Up', 'Child Master'),
    createPermission('Units', 'Child Master'),
    createPermission('Prescreening List', 'Child Master'),

    // Counselling
    createPermission('Counseling Impact Report', 'Counselling Reports'),
    createPermission('Challenges Report', 'Counselling Reports'),
    createPermission('Progress Report', 'Counselling Reports'),
    createPermission('Intervention Report', 'Counselling Reports'),
    createPermission('Comparison', 'Counselling Reports'),
    createPermission('Session Count', 'Counselling Reports'),
    createPermission('Followup Overview', 'Counselling Reports'),
    createPermission('Councelling Observation', 'Depository'),

    //Dashboard
    createPermission('Dashboard', 'Dashboard'),

    // Education
    createPermission('Education', 'Education'),
    createPermission('Individual Session', 'Education'),
    createPermission('Group Session', 'Education'),
    createPermission('Education Reports', 'Education'),
    createPermission('Followup Assessment', 'Education'),
    createPermission('Follow Up Question', 'Education'),

    // Education Reports
    createPermission('Education Report', 'Education Reports'),
    createPermission('Follow Up Report', 'Education Reports'),
    createPermission('MIS Report', 'Education Reports'),
    createPermission('Session Count', 'Education Reports'),
    createPermission('Education Impact Report', 'Education Reports'),
    createPermission('Report Card', 'Education Reports'),
    createPermission('Analytical Report', 'Education Reports'),

    // Inventory
    createPermission('Inventory', 'Inventory'),
    createPermission('Products', 'Inventory'),
    createPermission('Instock Entry', 'Inventory'),
    createPermission('Centre Inventory', 'Inventory'),
    createPermission('Stock Adjustment', 'Inventory'),
    createPermission('Stock Transfer', 'Inventory'),
    createPermission('Direct Issue', 'Inventory'),
    createPermission('Request Products', 'Inventory'),
    createPermission('Issue Requests', 'Inventory'),
    createPermission('Issued Products', 'Inventory'),
    createPermission('Purchase List', 'Inventory'),
    createPermission('Hygiene Kit', 'Inventory'),
    createPermission('Inventory Log', 'Inventory'),

    // Masters
    createPermission('Types', 'Masters'),
    createPermission('Audit Logs', 'Masters'),
    createPermission('Employees', 'Masters'),
    createPermission('Users', 'Masters'),
    createPermission('Prefix Master', 'Masters'),
    createPermission('Media', 'Masters'),
    createPermission('Glossary', 'Masters'),

    // Operations
    createPermission('Unit Sponsorship', 'Operations Dept'),
    createPermission('Feedback', 'Operations Dept'),
    createPermission('Testimonials', 'Operations Dept'),
    createPermission('Mealmate', 'Operations Dept'),
    createPermission('Bookings', 'Operations Dept'),
    createPermission('Centre Highlights', 'Operations Dept'),
    createPermission('Events', 'Operations Dept'),
    createPermission('Contacts', 'Operations Dept'),

    // Reports
    createPermission('Donation Report', 'Donation Reports'),
    createPermission('Attempted Donations', 'Donation Reports'),
    createPermission('Failed Donations', 'Donation Reports'),
    createPermission('Razorpay Payments', 'Donation Reports'),
    createPermission('Custom Payments', 'Donation Reports'),

    // Ops Reports
    ...['Child Report', 'Admission Report', 'Admission Yearly Report','Weekly Report',
      'Daily Child Report', 'Allergy Report', 'Duration Report',
      'State Count Report', 'Child Wise Hospital', 'Hospital Wise Occ.',
      'Hospital Count Report', 'Age Group Report', 'Unit & Floor Report',
      'Quarterly Report', 'Efficiency Report', 'Occupancy Report',
      'Blood Group Report', 'Gender Count Report', 'Yearly Count Report'
    ].map(name => createPermission(name, 'Ops Reports')),

    // Other Categories
    // createPermission('CMS'),
    createPermission('Centres','Masters'),
    createPermission('Hospitals','Masters'),
    createPermission('Units','Masters'),
    // createPermission('Unit'),
    createPermission('Donor','Donor Management'),

    // Transport
    createPermission('Vehicles', 'Transport'),
    createPermission('Drivers', 'Transport'),
    createPermission('Trip Log', 'Transport'),
    createPermission('Fuel Filling Log', 'Transport'),
    createPermission('Servicing Log', 'Transport'),

    // Donor Management
    createPermission('AI Powered Impact Report', 'Donor Management'),
    createPermission('Donor Profile', 'Donor Management'),
    createPermission('Visitor Profile', 'Donor Management'),

    // Tasks
    createPermission('Tasks', 'Tasks'),

    // Reminders
    createPermission('Birthdays', 'Reminders'),
    createPermission('Payments', 'Reminders'),
    createPermission('Followups', 'Reminders')
  ];

  // Filter out duplicates and null values
  return rawPermissions.filter((permission, index, self) =>
    permission !== null &&
    self.findIndex(p => p.functionName === permission.functionName) === index
  );
})();
